import axios from 'axios'
export default {
  getMunuIpInfo() {
    return axios.post('/api/rendering/admin/task/node/capacity/listMunuIpInfo')
  },
  exportNodeCapacityDetail(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/exportNodeCapacityDetail', params)
  },
  exportNodeCountDetail(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/exportNodeCountDetail', params)
  },
  exportMunuNodePropertyStat(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/exportMunuNodePropertyStat ', params)
  },
  exportMunuCapacity(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/exportMunuCapacity', params)
  },
  exportMunuNodeStat(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/exportMunuNodeStat', params)
  },
  exportRenderNodeStat(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/exportRenderNodeStat', params)
  },
  getMunuNodeCapacityDetailInfo(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/listMunuNodeCapacityDetail', params)
  },
  getMunuNodeCapacity(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/listMunuNodeCapacity', params)
  },
  getHardwareModelCapacityChart(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/listHardwareModelCapacityChart', params)
  },
  getPlatformCapacityUtilization(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/listMunuNodeCapacityTrend', params)
  },
  getMunuNodeCounts(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/listMunuNodeCounts', params)
  },
  queryActionInfos(params) {
    return axios.post('/api/rendering/admin/front/user/performance/queryActionInfos', params)
  },
  queryAllPerformanceData(params) {
    return axios.post('/api/rendering/admin/front/user/performance/queryAllPerformanceData', params)
  },
  queryPagePerformanceDetail(params) {
    return axios.post(
      '/api/rendering/admin/front/user/performance/queryPagePerformanceDetail',
      params,
    )
  },
  queryPerformanceListByAction(params) {
    return axios.post(
      '/api/rendering/admin/front/user/performance/queryPerformanceListByAction',
      params,
    )
  },
  exportPerformanceData(params) {
    return axios.post('/api/rendering/admin/front/user/performance/exportPerformanceData', params)
  },
  exportPagePerformanceDetail(params) {
    return axios.post(
      '/api/rendering/admin/front/user/performance/exportPagePerformanceDetail',
      params,
    )
  },
  queryTaskStatusData(params) {
    return axios.post('/api/rendering/admin/front/user/task/queryTaskStatusData', params)
  },
  queryTaskStatusDataDetail(params) {
    return axios.post('/api/rendering/admin/front/user/task/queryTaskStatusDataDetail', params)
  },
  queryTaskStatusDataTrend(params) {
    return axios.post('/api/rendering/admin/front/user/task/queryTaskStatusDataTrend', params)
  },
  exportTaskStatusDataDetail(params) {
    return axios.post('/api/rendering/admin/front/user/task/exportTaskStatusDataDetail', params)
  },
  exportPicTaskStatusDataDetail(params) {
    return axios.post('/api/rendering/admin/front/user/task/exportPicTaskStatusDataDetail', params)
  },
  getUserConversionInfo(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/userConversionInfo', params)
  },
  getUserConversionDetails(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/userConversionDetails', params)
  },
  getUserConversionList(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/userConversionList', params)
  },
  exportConversionList(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/exportConversionList', params)
  },
  exportAllConversionList(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/exportAllConversionList', params)
  },
  getUserRetentionList(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/userRetentionList', params)
  },
  exportUserRetentionList(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/exportUserRetentionList', params)
  },
  getUserAnalyticsData(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/getUserAnalyticsData', params)
  },
  getUserAnalyticsTrendData(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/getUserAnalyticsTrendData', params)
  },
  getUserDataStatPicBoardData(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/getPicBoardData', params)
  },
  getUserDataStatTrendChart(params) {
    return axios.post('/api/rendering/admin/front/user/data/stat/trendChart', params, {isCancelRaceApi: true})
  },
  queryHardwareOfflineData(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/queryHardwareOfflineData', params)
  },
  queryHardwareOfflineTrendChart(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/queryHardwareOfflineTrendChart', params)
  },
  exportHardwareOfflineData(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/exportHardwareOfflineData', params)
  },
  listMunuNodeHardware(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/listMunuNodeHardware', params)
  },
  exportNodeHardwareDetail(params) {
    return axios.post('/api/rendering/admin/task/node/capacity/exportNodeHardwareDetail', params)
  },
}
